import React from "react";
import "./Footer.css";
import { FaInstagram } from "react-icons/fa"; // Import icons from react-icons library
import { GiOstrich } from "react-icons/gi";
import { FaXTwitter } from "react-icons/fa6";
const Footer = () => {
  return (
    <footer className="footer">
      {/* Logo Section */}
      <div className="footer-logo">
        {/* <img src="/bulblogo.png" alt="Logo" className="logo" /> */}
        <p>Sound Money. Sound Creed.</p>
      </div>

      {/* Text Section */}
      {/* <div className="footer-text" style={{ fontSize: "30px" }}>
        <p>Sound Money. Sound Creed.</p>
      </div> */}

     
    </footer>
  );
};

export default Footer;
